module.exports = __webpack_public_path__ + "static/media/img_action_bar_android.3d4109d8.png";